import { frontendURL } from 'dashboard/helper/URLHelper.js';

const DisparosPage = () => import('./pages/DisparosPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/disparos'),
    name: 'disparos_dashboard_index',
    meta: {
      permissions: ['administrator'],
    },
    component: DisparosPage,
  },
];
